export const DEFAULT_COUNTRY = 'DE'
export const COOKIE_I18N = 'i18n_redirected'
